// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu[data-v-1221a528] {\n  padding: 5px;\n  height: 100%;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  flex: 1;\n  background-color: white;\n}\n.menu__body[data-v-1221a528] {\n  overflow: auto;\n  height: 100%;\n}\n.green[data-v-1221a528] {\n  color: #67c23a;\n}", ""]);
// Exports
module.exports = exports;
